/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme';

// COMPONENT
export function FontAwesomeIconStatus({ status, disabled, ...rest }) {
  if (disabled) {
    return <FontAwesomeIcon color={theme.palette.action.disabled} {...rest} />;
  }
  return <FontAwesomeIcon color={theme.palette[status]?.main ?? 'black'} {...rest} />;
}
